import { render, staticRenderFns } from "./backendAudit.vue?vue&type=template&id=8222c90c&scoped=true&lang=html&"
import script from "./backendAudit.vue?vue&type=script&lang=js&"
export * from "./backendAudit.vue?vue&type=script&lang=js&"
import style0 from "./backendAudit.vue?vue&type=style&index=0&id=8222c90c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8222c90c",
  null
  
)

component.options.__file = "backendAudit.vue"
export default component.exports